import { GA4Event } from "./GA4Event";

export function buildVideoEvent(model) {
	const { event, attributes } = model;
	const { eventData } = new GA4Event(event, {
		...attributes
	});
	return eventData;
}
